import { memo, useRef, useEffect } from "react";
import { PointIconName } from "PosterEditor/model/poster-types";
import { UIIconName, UIIconVariant, iconPath } from "./ui-icon-type";

export interface UIIconProps {
  iconName: UIIconName;
  variant: UIIconVariant;
  size?: number; // Width/height of icon (aspect ratio is always 1).
}

export const UIIcon = memo((props: UIIconProps) => {
  const size = props.size ?? 30;

  return (
    <img
      src={iconPath(props.iconName, props.variant)}
      width={size}
      height={size}
      alt={props.iconName}
      draggable={false}
      style={{ border: 0, boxShadow: "none" }}
    />
  );
});
